"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.process = exports.isEscapeQueued = exports.isEnterQueued = exports.addDirectKeyboardInpout_escape = exports.addDirectKeyboardInpout_enter = exports.addDirectKeyboardInpout_backspace = exports.addDirectKeyboardInpout = exports.getDirectKeyboardInputBuffer = exports.isKeyEntryMode = exports.clearKeyEntryMode = exports.setKeyEntryMode = exports.defaultAllowedInput = exports.space = exports.numeric = exports.alphaCaps = exports.alpha = void 0;
exports.alpha = 'abcdefghijklmnopqrstuvwxyz';
exports.alphaCaps = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
exports.numeric = '0123456789';
exports.space = ' ';
exports.defaultAllowedInput = exports.alpha + exports.alphaCaps + exports.numeric + exports.space;
var _keyEntryMode = '';
var _directKeyboardInputBuffer = '';
var _directKeyboardInputBufferMax = 10;
var _directKeyboardEnterQueued = false;
var _directKeyboardEscapeQueued = false;
var setKeyEntryMode = function (mode, inputBuffer, max) {
    if (_keyEntryMode !== mode) {
        _keyEntryMode = mode;
        _directKeyboardInputBuffer = inputBuffer;
        _directKeyboardInputBufferMax = max;
        _directKeyboardEnterQueued = false;
        _directKeyboardEscapeQueued = false;
    }
};
exports.setKeyEntryMode = setKeyEntryMode;
var clearKeyEntryMode = function (mode) {
    if (_keyEntryMode === mode) {
        _keyEntryMode = '';
        _directKeyboardEnterQueued = false;
        _directKeyboardEscapeQueued = false;
    }
};
exports.clearKeyEntryMode = clearKeyEntryMode;
var isKeyEntryMode = function () {
    return _keyEntryMode !== '';
};
exports.isKeyEntryMode = isKeyEntryMode;
var getDirectKeyboardInputBuffer = function () {
    return _directKeyboardInputBuffer;
};
exports.getDirectKeyboardInputBuffer = getDirectKeyboardInputBuffer;
var addDirectKeyboardInpout = function (c) {
    _directKeyboardInputBuffer += c;
    _directKeyboardInputBuffer = _directKeyboardInputBuffer.substring(0, _directKeyboardInputBufferMax);
};
exports.addDirectKeyboardInpout = addDirectKeyboardInpout;
var addDirectKeyboardInpout_backspace = function () {
    if (_directKeyboardInputBuffer.length > 0) {
        _directKeyboardInputBuffer = _directKeyboardInputBuffer.substring(0, _directKeyboardInputBuffer.length - 1);
    }
};
exports.addDirectKeyboardInpout_backspace = addDirectKeyboardInpout_backspace;
var addDirectKeyboardInpout_enter = function () {
    _directKeyboardEnterQueued = true;
};
exports.addDirectKeyboardInpout_enter = addDirectKeyboardInpout_enter;
var addDirectKeyboardInpout_escape = function () {
    _directKeyboardEscapeQueued = true;
};
exports.addDirectKeyboardInpout_escape = addDirectKeyboardInpout_escape;
var isEnterQueued = function () {
    return _directKeyboardEnterQueued;
};
exports.isEnterQueued = isEnterQueued;
var isEscapeQueued = function () {
    return _directKeyboardEscapeQueued;
};
exports.isEscapeQueued = isEscapeQueued;
var process = function (key) {
    if (exports.defaultAllowedInput.includes(key)) {
        (0, exports.addDirectKeyboardInpout)(key);
    }
    if (key === 'Space') {
        (0, exports.addDirectKeyboardInpout)(' ');
    }
    if (key === 'Backspace' || key === 'Delete' || key === 'ArrowLeft') {
        (0, exports.addDirectKeyboardInpout_backspace)();
    }
    if (key === 'Enter' || key === 'NumPadEnter') {
        (0, exports.addDirectKeyboardInpout_enter)();
    }
    if (key === 'Escape') {
        (0, exports.addDirectKeyboardInpout_escape)();
    }
};
exports.process = process;
